import axios from 'axios';
import { UserContext } from '../../../../context/UserContext';
import { useContext } from 'react';
import { ApiException } from '../../logging/api/api-exception/apiException';
import getCatalyticsApiUrl from '../../../../data/Urls';

const GetLineItems = async (advertiserId) => {
  let lineItemsResponse = {
    status: false,
    error: '',
    info: {},
  };
  const { userInfo: currentUserInfo } = useContext(UserContext);
  const { username, id, signInDetails } = currentUserInfo;
  const { accessToken, idToken } = currentUserInfo;
  const request = { advertiser_id: advertiserId };
  await axios
    .get(getCatalyticsApiUrl() + 'line-items/', {
      params: {
        advertiser_id: advertiserId,
      },
      headers: {
        Authorization: `Basic ${accessToken}`,
      },
    })
    .then(async (response) => {
      if (response['data'] === null) {
        lineItemsResponse.error = 'Empty response from GET line items';
        ApiException(
          lineItemsResponse.error,
          { email: currentUserInfo['attributes']['email'] },
          request,
          response
        );
        return;
      }
      let body = JSON.parse(response['data']['body']);
      if (body['line-items'] === undefined) {
        lineItemsResponse.error = 'Invalid response from GET line items';
        ApiException(
          lineItemsResponse.error,
          { email: currentUserInfo['attributes']['email'] },
          request,
          body
        );
        return;
      }
      lineItemsResponse.status = true;
      lineItemsResponse.info = body['line-items'];
      //lineItemsResponse = await CreateInsertionOrders(advertiserId, name);
    })
    .catch(function (error) {
      lineItemsResponse.error = error;
      ApiException(
        lineItemsResponse.error,
        { email: currentUserInfo['attributes']['email'] },
        request,
        {}
      );
    });
  return lineItemsResponse;
};

export default GetLineItems;
